import { useState } from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { ArrowRight, Play } from 'lucide-react';

import { MARKETING_APP_ENTRY_HREF } from '../marketingContent';
import { PrimaryCTA } from '../components/PrimaryCTA';
import { SecondaryCTA } from '../components/SecondaryCTA';
import { SectionWrapper } from '../components/SectionWrapper';

import setupVideoUrl from '@/videos/Instructor account creation 1_edit_small.mp4';
import styles from './HeroSection.module.css';

export function HeroSection() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);

  return (
    <SectionWrapper background="white" data-testid="marketing-section-hero">
      <div className={styles.layout}>
        <div className={styles.copy}>
          <p className={styles.eyebrow}>Education&apos;s technology layer.</p>
          <h1 className={styles.title}>A complete modern course in 2 minutes.</h1>
          <p className={styles.subhead}>
            Kudu is one platform that replaces your publisher, homework
            system, clicker, and AI subscription. Start with a pre-built course
            and go, or build your own from your materials. At a price your
            students can actually afford.
          </p>

          <div className={styles.actions}>
            <PrimaryCTA
              href={MARKETING_APP_ENTRY_HREF}
              icon={<ArrowRight aria-hidden="true" size={16} />}
              label="Start a free course in 2 minutes"
            />
            <SecondaryCTA
              icon={<Play aria-hidden="true" size={16} />}
              label="Watch the 2-minute setup"
              onClick={() => setIsVideoOpen(true)}
            />
          </div>

          <p className={styles.caption}>
            Free for instructors. $25 per student per semester. No credit card
            required to try.
          </p>
        </div>

        <div aria-hidden="true" className={styles.media}>
          <div className={styles.mediaFrame}>
            <div className={styles.browserChrome}>
              <span className={styles.chromeDot} />
              <span className={styles.chromeDot} />
              <span className={styles.chromeDot} />
            </div>
            {/* Decorative, silent preview loop; the dialog below offers the
                full video with controls. */}
            <div className={styles.mediaViewport}>
              <video
                autoPlay
                className={styles.mediaVideo}
                loop
                muted
                playsInline
                src={setupVideoUrl}
                tabIndex={-1}
              />
            </div>
          </div>
        </div>
      </div>

      <Dialog.Root onOpenChange={setIsVideoOpen} open={isVideoOpen}>
        <Dialog.Portal>
          <Dialog.Overlay className={styles.videoOverlay} />
          <Dialog.Content className={styles.videoContent}>
            <Dialog.Title className={styles.videoTitle}>
              2-minute setup video
            </Dialog.Title>
            <Dialog.Description className={styles.videoDescription}>
              Watch an instructor account get created and a course set up, start
              to finish, in about two minutes.
            </Dialog.Description>
            <video
              autoPlay
              className={styles.videoPlayer}
              controls
              playsInline
              src={setupVideoUrl}
            />
            <div className={styles.videoActions}>
              <SecondaryCTA
                label="Close"
                onClick={() => setIsVideoOpen(false)}
              />
            </div>
          </Dialog.Content>
        </Dialog.Portal>
      </Dialog.Root>
    </SectionWrapper>
  );
}
